<template>
<header>
    <img src="../assets/Logo.png" alt="Bild nicht geladen" class="logo">
    <div>
        <router-link >Mitarbeiter</router-link>
    </div>
</header>
</template>

<script>
export default {
name: 'MainHeader'
}
</script>

<style scoped>
header{
    width: 100%;
    display: flex;
    justify-content: space-around;
}
.logo{
    height: 70px;
}
</style>